<fm-update-address-banner
    *ngIf="(userService.currentUser | async).planInfo.addressUpdateNeeded"
    class="w-full z-40"
    [ngClass]="{
        'fixed top-0': isBannerSticky,
        relative: !isBannerSticky,
    }" />
<fm-maintenance-banner
    *ngIf="showMaintenanceBanner"
    class="w-full z-50"
    [ngClass]="{
        'fixed top-0': isBannerSticky,
        relative: !isBannerSticky,
    }" />

@if (threeColumnLayout) {
    <div class="h-dvh flex flex-col md:flex-row md:h-screen bg-oatmilk">
        <nav class="w-full md:w-16 md:min-w-16 md:order-1 order-3 md:mr-4">
            <fm-navigation />
        </nav>

        <!-- Left Panel -->
        <div class="w-full order-2 md:my-2 md:mr-2 md:w-[248px] md:min-w-[248px]">
            <fm-left-panel [hideBookingHubOnMobile]="hideBookingHubOnMobile" />
        </div>

        <!-- Middle Content -->
        <div
            class="flex-1 overflow-auto md:overflow-hidden order-1 md:order-3 md:my-2 md:mr-2 bg-white">
            <router-outlet></router-outlet>
        </div>

        <!-- Right Panel -->
        <div class="hidden order-4 my-2 mr-2 md:flex">
            <fm-right-panel />
        </div>
    </div>
} @else {
    <router-outlet></router-outlet>
}
